import { useState, useEffect } from 'preact/hooks';
import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '../../../store/selectors';
import { selectOnboardingStep } from '../slice';

const getHasBookmarksBar = (): boolean =>
  typeof window === 'undefined'
    ? true
    : window.outerHeight - window.innerHeight > 90;

const callbacks = [];
let hasBookmarksBar = getHasBookmarksBar();

if (typeof window !== 'undefined') {
  setInterval(() => {
    hasBookmarksBar = getHasBookmarksBar();
    callbacks.forEach((fn) => fn(hasBookmarksBar));
  }, 1000);
}

const useHasBookmarks = () => {
  return true;
};

export default useHasBookmarks;
